import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../environments/environment';
import {
  BehaviorSubject,
  catchError,
  map,
  Observable,
  of,
  switchMap,
} from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control':
        'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      Expires: '0',
    }),
  };
  private apiUrl: string = `${environment.api}`;

  private activePeriod$ = new BehaviorSubject<number>(3); // 3 for monthly
  private topN = 5;

  private http = inject(HttpClient);

  constructor() {}
  setActivePeriod(period: number): void {
    this.activePeriod$.next(period);
  }

  getCountries$(): Observable<any> {
    return this.activePeriod$.pipe(
      switchMap((period) => this.getEmergenciesByCountry(period, this.topN))
    );
  }

  getCities$(): Observable<any> {
    return this.activePeriod$.pipe(
      switchMap((period) => this.getEmergenciesByCities(period, this.topN))
    );
  }

  getAlertCount$(countries$: Observable<any>): Observable<number> {
    return countries$.pipe(
      map((countries) => {

        if (!countries) return 0;
        return countries.reduce(
          (count: any, country: any) => count + Number(country.count),
          0
        );
      })
    );
  }
  getMessageCount$(): Observable<any> {
    return this.activePeriod$.pipe(
      switchMap((period) =>
        this.getMessagesCount(period, this.topN).pipe(
          map((value) => {
            return value.count;
          })
        )
      )
    );
  }

  getEmergenciesByCountry(period: number, topN: number): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/Emergency/sum-countries?filterId=${period}&topN=${topN}`,
        this.httpOptions
      )
      .pipe(
        catchError((err) => {
          console.error(err);
          return of([]);
        })
      );
  }
  getEmergenciesByCities(period: number, topN: number): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/Emergency/sum-cities?filterId=${period}&topN=${topN}`,
        this.httpOptions
      )
      .pipe(
        catchError((err) => {
          console.error(err);
          return of([]);
        })
      );
  }
  getMessagesCount(period: number, topN: number): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/Chat/sum-messages?filterId=${period}&topN=${topN}`,
        this.httpOptions
      )
      .pipe(
        catchError((err) => {
          console.error(err);
          return of([]);
        })
      );
  }
}
